import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Divider, Fade, Menu, MenuItem } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ReactComponent as ArrowIcon } from "assets/icons/arrowIcon.svg";

const useStyles = makeStyles()((theme) => ({
	mainContainer: {
		display: "flex",
		cursor: "pointer",
	},
	icon: {
		"&:hover": {
			cursor: "pointer",
		},
	},
	arrowContainer: {
		display: "flex",
		alignItems: "center",
		marginTop: "1rem",
	},
}));

const CommonDropdown = ({
	iconSrc,
	isDownloading,
	dataSource,
	dynamicAction,
	footerItem,
	footerItems,
}) => {
	const { classes, cx } = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const openDropdown = Boolean(anchorEl);

	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			{isDownloading ? (
				<CircularProgress />
			) : (
				<div className={classes.mainContainer} onClick={handleOpen}>
					<img
						alt="Print"
						src={iconSrc}
						style={{ marginRight: "5px", width: "30px", height: "auto" }}
						className={classes.printIcon}
					/>

					<div className={classes.arrowContainer}>
						<ArrowIcon
							className="arrow-down"
							style={{ width: "8px", height: "8px" }}
						/>
					</div>
				</div>
			)}

			<Menu
				id="print-menu"
				getContentAnchorEl={null}
				anchorEl={anchorEl}
				open={openDropdown}
				onClose={handleClose}
				TransitionComponent={Fade}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				{dataSource.map((report) => (
					<MenuItem
						key={report?.id ?? report?.name}
						data-testid={report?.reportType ? `common-dropdown-item-${report.reportType}` : undefined}
						onClick={() => dynamicAction(report, handleClose)}
					>
						{report?.name}
					</MenuItem>
				))}
				{(() => {
					// Accept either a single `footerItem` or a `footerItems` array.
					// Existing callers stay one-line; new callers can stack items.
					const items = footerItems
						? footerItems
						: footerItem
						? [footerItem]
						: [];
					if (items.length === 0) return null;
					const result = [<Divider key="footer-divider" />];
					items.forEach((item, idx) => {
						result.push(
							<MenuItem
								key={`footer-item-${idx}`}
								onClick={() => {
									handleClose();
									item.onClick?.();
								}}
							>
								{item.icon ? (
									<span style={{ marginRight: "8px", display: "inline-flex" }}>
										{item.icon}
									</span>
								) : null}
								{item.label}
							</MenuItem>
						);
					});
					return result;
				})()}
			</Menu>
		</div>
	);
};

export default CommonDropdown;
